import { Link } from 'react-router-dom';

import { Button } from '@app/shared/ui/atoms/Common';
import { defaultTelegramVibrate } from '@app/shared/utils/common';
import { Page } from '@app/routes';
import { questionIcon } from '@app/assets';

export function TopBar() {
  return (
    <div className="flex items-center justify-between">
      <Button
        variant="custom"
        className="flex ml-auto size-8 items-center justify-center rounded-full bg-[#3E3B3B99]"
        onClick={defaultTelegramVibrate}
        asChild
      >
        <Link to={Page.DAILY_ENERGY_DESCRIPTION}>
          <img
            src={questionIcon}
            alt="daily energy description"
            className="size-5 text-foreground"
          />
        </Link>
      </Button>
    </div>
  );
}
